<template>
  <div class="cont">
    <div class="inner">
      <div ref="desc" class="pos">
        <h3>{{game.name}}</h3>
        <div class="copy" v-html="game.description"></div>
        <div v-if="game.steamUrl" class="steamLinkWrap">
          <llink
            class="steamLink"
            :color="'rgb(69, 101, 120)'"
            :href="game.steamUrl"
            target="_blank"
          >
            Wishlist on Steam
          </llink>
        </div>
      </div>
    </div>
    <div class="gImg" :style="imageStyle" />
  </div>
</template>

<script>
import llink from './LL_Link.vue';

export default {
  name: 'llgame',
  components: {
    llink
  },
  props: {
    game: {
      type: Object,
    }
  },
  data() {
    return{
      i: null
    }
  },
  computed: {
    imageStyle() {
      return this.i
        ? { backgroundImage: `url('${this.i}')` }
        : { backgroundImage: 'linear-gradient(135deg, rgba(58, 80, 94, 0.9), rgba(18, 26, 30, 0.98))' };
    }
  },
  methods: {

  },
  mounted(){
    try {
      this.i = require('../assets/LostLake/games/' + this.game.img);
    } catch (error) {
      this.i = null;
    }
    if((this.$vnode.key+1) % 2 == 0){
      this.$refs['desc'].style.float = "left";
    } else {
      this.$refs['desc'].style.float = "right";
    }
  }
}
</script>

<style scoped>
@media(max-width: 768px){
  .cont{
    height: 100vh;
    min-height: 640px;
    margin-bottom: 0;
  }
  .inner{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    padding: 0 16px;
    box-sizing: border-box;
  }
  .pos{
    float: none !important;
    width: 100%;
    max-width: 420px;
    height: auto;
    min-height: 0;
    padding: 20px;
    background-color: rgba(0, 0, 0, .7);
    border: 1px solid rgba(69, 101, 120, .45);
  }
  .pos h3{
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 1.8em;
  }
  .copy{
    width: 100%;
    font-size: .95em;
    line-height: 1.65;
  }
  .copy :deep(p){
    margin-bottom: 1.2em;
  }
  .steamLinkWrap{
    margin-top: 20px;
  }
  .gImg{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-position: calc(50% + 200px) center;
  }
}

.cont{
  position: relative;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  overflow: hidden;
  }
  .pos{
    background-color: rgba(0, 0, 0, .7);
    padding: 30px;
    box-sizing: border-box;
    height: 100%;
    float: left;
    }
    .pos h3{
      font-family: 'inputSerif';
      font-size: 2.4em;
      margin-bottom: 30px;
      margin-top: 100px;
      }
      .copy{
        color: rgb(151, 191, 222);
        width: 360px;
        line-height: 1.7;
        font-family: 'inputSerifCondensed';
        font-size: 1em;
        }
      .copy :deep(p){
        margin-bottom: 18px;
      }
      .copy :deep(p:last-child){
        margin-bottom: 0;
      }
      .steamLinkWrap{
        display: flex;
        justify-content: center;
        margin-top: 28px;
      }
      .steamLink{
        font-family: 'inputSerif';
        font-size: .95em;
        font-weight: 900;
        letter-spacing: .03em;
        text-transform: uppercase;
      }
.inner{
  width: 1200px;
  height: 100%;
  z-index: 2;
  position: relative;
  align-self: center;
  }
    .gImg{
      z-index: 1;
      width: 100%;
      background-repeat:no-repeat;
      background-size: cover;
      height: 100%;
      position: absolute;
      top:0px;
      }
</style>
